import React from 'react';
import { ProgressBar } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const FileUploadProgress = ({ progress }) => {
  const {t} = useTranslation()

  return (
    <UploadContainer className='m-3'>
      <Title>{t("uploading")}</Title>
      <ProgressText>{t('progress')}: {progress}%</ProgressText>
      <StyledProgressBar now={progress} />
      {/* <StyledProgressBar now={progress} label={`${progress}%`} /> */}
    </UploadContainer>
  );
};

export default FileUploadProgress;


const UploadContainer = styled.div`
  /* border: 1px solid var(--border); */
  border-radius: 8px;
  padding: 20px;
  width: 100%;
`;

const Title = styled.h3`
  font-size: 18px;
  color: #333333;
  font-weight: bold;
  margin-bottom: 10px;
`;

const ProgressText = styled.p`
  font-size: 14px;
  color: var(--text);
  margin-bottom: 10px;
`;

const StyledProgressBar = styled(ProgressBar)`
  height: 10px;
  background-color: #f1f5f9;
  .progress-bar {
    background-color: var(--themeColor); /* Primary theme color */
  }
`;